import { useZero } from "@rocicorp/zero/react";
import { useState } from "react";
import { sharedMutators } from "../../shared/mutators";
import { classifyZeroResult } from "../lib/zeroResultError";
import { Button } from "./Button";
import { EmptyState } from "./EmptyState";

type Props = {
  runId: string | null;
  onRevealed: () => void;
};

export function HiddenRunContent({ runId, onRevealed }: Props) {
  const z = useZero();
  const [revealing, setRevealing] = useState(false);
  const [error, setError] = useState<string>();

  const reveal = async (runId: string) => {
    setRevealing(true);
    setError(undefined);
    const result = await z.mutate(sharedMutators.revealRunData({ runId }))
      .server;
    setRevealing(false);
    if (result.type === "error") {
      const decision = classifyZeroResult(result);
      setError(
        (decision.kind === "toast" && decision.message) ||
          "Couldn’t show this run. Try again."
      );
      return;
    }
    onRevealed();
  };

  return (
    <EmptyState
      iconName="eye-closed"
      iconSize={24}
      maxWidth={260}
      title="This run used someone else’s connected account"
      description={
        error ??
        "Its content is hidden. Viewing it is recorded in the audit log."
      }
      action={
        runId && (
          <Button
            variant="secondary"
            disabled={revealing}
            onClick={() => void reveal(runId)}
          >
            View anyway (logged)
          </Button>
        )
      }
    />
  );
}
